"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "calculateValueFromSquareFootageEstimate", {
    enumerable: true,
    get: function() {
        return calculateValueFromSquareFootageEstimate;
    }
});
const calculateValueFromSquareFootageEstimate = ({ sqftOfProperty, costPerSqft, adjustmentRatio })=>{
    return sqftOfProperty * costPerSqft * adjustmentRatio;
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NlcnZpY2VzL2Zvcm1CdWlsZGVyU2VydmljZS91dGlscy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgY29uc3QgY2FsY3VsYXRlVmFsdWVGcm9tU3F1YXJlRm9vdGFnZUVzdGltYXRlID0gKHtcbiAgc3FmdE9mUHJvcGVydHksXG4gIGNvc3RQZXJTcWZ0LFxuICBhZGp1c3RtZW50UmF0aW8sXG59OiB7XG4gIHNxZnRPZlByb3BlcnR5OiBudW1iZXI7XG4gIGNvc3RQZXJTcWZ0OiBudW1iZXI7XG4gIGFkanVzdG1lbnRSYXRpbzogbnVtYmVyO1xufSkgPT4ge1xuICByZXR1cm4gc3FmdE9mUHJvcGVydHkgKiBjb3N0UGVyU3FmdCAqIGFkanVzdG1lbnRSYXRpbztcbn07XG4iXSwibmFtZXMiOlsiY2FsY3VsYXRlVmFsdWVGcm9tU3F1YXJlRm9vdGFnZUVzdGltYXRlIiwic3FmdE9mUHJvcGVydHkiLCJjb3N0UGVyU3FmdCIsImFkanVzdG1lbnRSYXRpbyJdLCJtYXBwaW5ncyI6Ijs7OzsrQkFBYUE7OztlQUFBQTs7O0FBQU4sTUFBTUEsMENBQTBDLENBQUMsRUFDdERDLGNBQWMsRUFDZEMsV0FBVyxFQUNYQyxlQUFlLEVBS2hCO0lBQ0MsT0FBT0YsaUJBQWlCQyxjQUFjQztBQUN4QyJ9